<button
    class="btn btn-secondary nav-item"
    [ngClass]="{ isParticipant: (isParticipantSelected | async), 'btn-lg': isMobile }"
    type="button"
    #participantCopiesButton
    #tooltip="bs-tooltip"
    [tooltip]="'F4M_TOOLTIP_SELECT_PARTICIPANT_COPY_LABEL' | translate"
    (click)="tooltip.hide(); toggleDropup($event)"
>
    <span *ngIf="isParticipantSelected | async" class="me-1"><fa-icon [icon]="faUser"></fa-icon></span>
    {{ getLabel(selectedParticipantCopy$ | async) }}
</button>
<div class="background" *ngIf="showDropupMenu" (click)="toggleDropup()"></div>
<ul class="dropdown-menu" role="menu" #participantCopiesDropupMenu [ngClass]="{ show: showDropupMenu }">
    <li *ngFor="let copy of participantCopies$ | async" role="menuitem">
        <a
            class="dropdown-item"
            (click)="onSelected(copy.id)"
            [ngClass]="{ 'highlight-selection': copy.id === (selectedParticipantCopyId$ | async), 'py-2': isMobile }"
        >
            {{ getLabel(copy) }}</a
        >
    </li>
</ul>
